import { FilesService } from '@/api'
import PaneContainer from '@/layouts/components/PaneContainer'
import SingleColumn from '@/layouts/SingleColumn'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { Button } from 'primereact/button'
import { Card } from 'primereact/card'
import Welcome from './sections/Welcome'
import CurrentFile from './sections/CurrentFile'

function Dashboard() {
  const navigate = useNavigate()
  const selectedFileQuery = useQuery({
    queryKey: ['selectedFile'],
    queryFn: () => FilesService.selectedFiles(),
    refetchOnWindowFocus: false,
  })

  const selectedFile = selectedFileQuery.data?.files?.[0]
  const actionsDisabled = selectedFileQuery.isLoading || !selectedFile

  const actions = [
    {
      key: 'csv-import',
      title: 'CSV取り込み',
      description: 'CSVファイルを取り込み、OneDriveで選択したファイルに転記します。',
      icon: 'pi pi-upload',
      label: 'CSVを取り込む',
      to: '/import-csv',
    },
    {
      key: 'monthly-plan',
      title: '月間生産計画の作成',
      description: '取り込んだデータをもとに最適化ロジックで月間の生産計画を作成します。',
      icon: 'pi pi-calendar',
      label: '月間計画を作成',
      to: '/create-plan',
    },
    {
      key: 'staff',
      title: 'スタッフ管理',
      description: 'スタッフ情報を管理します。',
      icon: 'pi pi-users',
      label: 'スタッフを管理',
      to: '/staff',
    },
    {
      key: 'detailed-plan',
      title: '詳細生産計画の作成',
      description: '月間計画を人員シフトを考慮して調整し、詳細な生産計画として確定します。',
      icon: 'pi pi-sitemap',
      label: '詳細計画を確認',
      to: '/detailed-plan',
    },
  ] as const

  return (
    <SingleColumn>
      <PaneContainer>
        <div className="tw-grid tw-grid-cols-1 gap-4 w-9 mx-auto">
          <h1 className="text-2xl font-medium mb-3">ダッシュボード</h1>
          <Welcome />
          <CurrentFile />
          <Card className="shadow-2" title="次の操作">
            <p className="text-700 mb-3">
              OneDriveでファイルを選択すると、以下の操作に進むことができます。
            </p>
            <div className="flex flex-column gap-3">
              {actions.map((action) => (
                <div
                  key={action.key}
                  className="flex flex-column md:flex-row align-items-start md:align-items-center justify-content-between gap-3 border-1 surface-border border-round p-3"
                >
                  <div className="flex align-items-start gap-3">
                    <span className="p-2 border-circle bg-primary-50 text-primary-700 flex align-items-center justify-content-center" style={{ width: '2.75rem', height: '2.75rem' }}>
                      <i className={action.icon} />
                    </span>
                    <div>
                      <h3 className="m-0 text-lg font-medium">{action.title}</h3>
                      <p className="m-0 text-600 text-sm line-height-3">{action.description}</p>
                    </div>
                  </div>
                  <Button
                    label={action.label}
                    icon="pi pi-arrow-right"
                    onClick={() => navigate({ to: action.to })}
                    disabled={actionsDisabled && action.key !== 'staff'}
                    severity="success"
                  />
                </div>
              ))}
            </div>
            {actionsDisabled ? (
              <small className="text-600 mt-3 block">ファイルを選択するとボタンが有効になります。</small>
            ) : (
              <small className="text-600 mt-3 block">選択中のファイル：{selectedFile?.original_name}</small>
            )}
          </Card>
        </div>
      </PaneContainer>
    </SingleColumn>
  )
}

export default Dashboard
